import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';
import store from '@app/store';
import { appConfig } from '@/config/app-config';

export const configurationPosRoutes = [
  {
    path: 'pos-boxes',
    name: 'admin-pos-boxes',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_boxes],
      module: ModulesHelper.POS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-pos-boxes" */ '@pos/pages/pos-boxes/pos-boxes.vue'),
  },
];

export const mainPosRoutes = [
  {
    path: 'pos-sessions',
    name: 'admin-pos-sessions',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_sessions],
      module: ModulesHelper.POS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-pos-boxes" */ '@pos/pages/pos-sessions/pos-sessions.vue'),
  },
  {
    path: 'pos-incidents',
    name: 'admin-pos-incidents',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_incidents],
      module: ModulesHelper.POS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-pos-boxes" */ '@pos/pages/pos-incidents/pos-incidents.vue'
      ),
  },
  {
    path: 'pos-articles',
    name: 'admin-pos-articles',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.articles],
      module: ModulesHelper.POS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-articles" */ '@pos/pages/pos-articles/pos-articles.vue'),
  },

  {
    path: 'pos/:initialPosSessionId',
    name: 'pos-page',
    props: true,
    beforeEnter: (to, from, next) => {
      if (!appConfig.modules.activatePosV2) {
        return false;
      }

      const settings = store.getters['centerSettings/centerSettings'];
      if (settings) {
        if (settings.use_pos_v2) {
          next();
        }
      }

      return false;
    },
    meta: {
      layout: 'bpc-pos',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_sessions],
      module: ModulesHelper.POS_MODULE_NAME,
    },
    component: () => import(/* webpackChunkName: "admin-articles" */ '@pos/pages/pos-page.vue'),
  },
];
